  function pickMatchesLive(p){
    if (!liveEnabled()) return Promise.resolve(pickMatches(p));
    var handle = CAT_COLLECTION[p.cat];
    var dexOk = function(c){ return c.dex === p.hand; };
    return storefront({ handle: handle, n: STOREFRONT.poolSize, filters: buildFilters(p, true) })
      .then(function(nodes){
        var items = nodes.map(mapNode).filter(dexOk);
        if (items.length) return { items: rankPool(items, p), note: "" };
        // nothing in budget -> relax price, keep dexterity (the hard filter)
        return storefront({ handle: handle, n: STOREFRONT.poolSize, filters: buildFilters(p, false) })
          .then(function(n2){
            var i2 = n2.map(mapNode).filter(dexOk).sort(function(a,b){ return a.price-b.price; });
            return i2.length ? { items: i2.slice(0,6), note: "budget" } : { items: [], note: "none" };
          });
      })
      .catch(function(err){
        try { console.warn("Club Finder: live fetch failed, using snapshot —", err && err.message); } catch(e){}
        return pickMatches(p);
      });
  }

  function renderLoading(){
    var s = el('<section class="step wide fade"></section>');
    s.innerHTML =
      '<div class="res-head"><div class="kicker">Your Club Finder result</div>' +
      '<h1>Finding your matches\u2026</h1></div>' +
      '<div style="margin-top:34px;display:flex;align-items:center;gap:12px;font-size:16px;color:var(--ink-soft)">' +
        '<span class="live-dot"></span> Checking live stock at recreationstation.co.nz for your fit\u2026</div>';
    swap(s);
  }
  // ================================================================ /LIVE STOREFRONT WIRING

  // ---------------------------------------------------------------- state
  var state = { step: 0, hand: "R", gender: "mens", answers: {} };
  var app = document.getElementById("app");
  var bar = document.getElementById("bar");
  var stepCount = document.getElementById("stepCount");

  // Each club type has its own question flow (Q1 is always first). Q1 decides the path; the rest
  // come from categoryFlow(). Before Q1 is answered we assume "set" so the progress estimate is sane.
  function flow() {
    var c = state.answers.q1 || "set";
    return [Q1].concat(categoryFlow(c === "notsure" ? "set" : c));
  }
  function total() { return flow().length; }

  function setBar() {
    var T = total();
    var pct = state.step === 0 ? 0 : state.step > T ? 100 : (state.step / T) * 100;
    bar.style.width = pct + "%";
    stepCount.textContent = state.step === 0 ? "Club Finder" : state.step > T ? "Your results" : "Question " + state.step + " of " + T;
  }

  function el(html) { var d = document.createElement("div"); d.innerHTML = html.trim(); return d.firstChild; }
  function esc(s){ return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;"); }

  // ---------------------------------------------------------------- render
  function render() {
    setBar();
    window.scrollTo(0, 0);
    if (state.step === 0) return renderIntro();
    var f = flow();
    if (state.step > f.length) return renderResults();
    return renderQuestion(f[state.step - 1]);
  }

  function renderIntro() {
    var s = el('<section class="step fade"></section>');
    s.innerHTML =
      '<span class="intro-flag">● &nbsp;New · Club Finder</span>' +
      '<h1 class="intro-title">Find the clubs that<br>actually fit your game.</h1>' +
      '<p class="intro-body">Like having our in-store fitter in your pocket. Answer a few quick questions about your game and budget — and we\'ll match you to the right used clubs, already condition-graded and in stock. <b>Every path is tailored to the club you pick.</b></p>' +
      '<div class="intro-meta"><span><b>Up to 6 questions</b> · about 2 minutes</span><span><b>Personalised</b> to your swing</span><span><b>Free</b> · no signup to see results</span></div>' +
      '<div class="seg-group">' +
        '<div class="seg-block"><div class="seg-label">You play</div><div class="seg" id="segHand">' +
          '<button data-v="R">Right-handed</button><button data-v="L">Left-handed</button></div></div>' +
        '<div class="seg-block"><div class="seg-label">Fit for</div><div class="seg" id="segGender">' +
          '<button data-v="mens">Men\'s</button><button data-v="womens">Women\'s</button><button data-v="junior">Junior</button></div></div>' +
      '</div>' +
      '<ul class="intro-list">' +
        '<li><span class="n">1</span><span>What you\'re shopping for</span></li>' +
        '<li><span class="n">2</span><span>A few quick fit questions, tailored to that club</span></li>' +
        '<li><span class="n">3</span><span>What matters most to you</span></li>' +
        '<li><span class="n">4</span><span>Your budget</span></li>' +
      '</ul>' +
      '<div class="nav-row" style="justify-content:flex-start;margin-top:34px;">' +
        '<button class="btn solid lg" id="startBtn">Start the Club Finder →</button></div>';
    swap(s);
    var segHand = s.querySelector("#segHand"), segGender = s.querySelector("#segGender");
    function paint(g, key){ [].forEach.call(g.children, function(b){ b.classList.toggle("on", b.dataset.v === state[key]); }); }
    paint(segHand, "hand"); paint(segGender, "gender");
    segHand.onclick = function(e){ if(e.target.dataset.v){ state.hand = e.target.dataset.v; paint(segHand,"hand"); } };
    segGender.onclick = function(e){ if(e.target.dataset.v){ state.gender = e.target.dataset.v; paint(segGender,"gender"); } };
    s.querySelector("#startBtn").onclick = function(){ go(1); };
  }

  function renderQuestion(q) {
    var s = el('<section class="step fade"></section>');
    var cur = state.answers[q.id];
    var opts = q.optionsFor ? q.optionsFor(state) : q.options;
    var optHtml = opts.map(function(o, i){
      var mk = q.two ? String.fromCharCode(65 + i) : String(i + 1);
      var subHtml = o.sub ? '<span class="sub">' + esc(o.sub) + '</span>' : '';
      return '<button class="opt' + (cur === o.v ? ' selected' : '') + '" data-v="' + o.v + '">' +
        '<span class="mk">' + mk + '</span>' +
        '<span class="txt"><span class="lab">' + esc(o.lab) + '</span>' + subHtml + '</span>' +
        '<span class="arrow">→</span></button>';
    }).join("");
    s.innerHTML =
      '<div class="kicker">Question ' + state.step + ' of ' + total() + '</div>' +
      '<h2 class="q-title">' + q.title + '</h2>' +
      '<p class="q-help">' + esc(q.help) + '</p>' +
      '<div class="opts ' + (q.two ? 'two' : '') + '">' + optHtml + '</div>' +
      '<div class="nav-row">' +
        '<button class="btn ghost" id="backBtn">← Back</button>' +
        '<button class="btn solid" id="nextBtn"' + (cur ? '' : ' disabled') + '>' + (state.step === total() ? 'See my matches →' : 'Continue →') + '</button>' +
      '</div>';
    swap(s);
    s.querySelector("#backBtn").onclick = function(){ go(state.step - 1); };
    var nextBtn = s.querySelector("#nextBtn");
    nextBtn.onclick = function(){ if(state.answers[q.id]) go(state.step + 1); };
    [].forEach.call(s.querySelectorAll(".opt"), function(btn){
      btn.onclick = function(){
        state.answers[q.id] = btn.dataset.v;
        [].forEach.call(s.querySelectorAll(".opt"), function(b){ b.classList.toggle("selected", b === btn); });
        nextBtn.removeAttribute("disabled");
        setTimeout(function(){ go(state.step + 1); }, 240);
      };
    });
  }

  // ---------------------------------------------------------------- fit logic
  function flexName(fc){
    var nm = { senior:"Senior", regular:"Regular", stiff:"Stiff", xstiff:"X-Stiff", ladies:"Ladies", junior:"Junior" };
    if (Array.isArray(fc)) return fc.map(function(x){ return nm[x] || x; }).join(" / ");
    return nm[fc] || fc;
  }
  function flexFromDriver(v, game){
    var m = { u200:["senior","regular"], "200_230":"regular", "230_260":"stiff", "260plus":["stiff","xstiff"] };
    if (m[v]) return m[v];
    return (game === "solid" || game === "low") ? "stiff" : "regular"; // "no idea" -> infer from game
  }
  function flexFrom7iron(v){
    var m = { u105:["senior","regular"], "105_120":"regular", "120_135":"stiff", "140_155":["stiff","xstiff"], "160plus":"xstiff" };
    return m[v] || "regular";
  }

  function buildProfile() {
    var a = state.answers;
    var rawCat = a.q1 || "set";
    var cat = rawCat === "notsure" ? "set" : rawCat;
    var fullSwing = (cat==="driver"||cat==="fairway"||cat==="hybrid"||cat==="irons"||cat==="set");
    var genderless = (cat==="wedges"||cat==="putter"); // gender doesn't filter wedges/putters
    var hand = state.hand, genderKey = state.gender;
    var handLabel = hand==="L" ? "Left-handed" : "Right-handed";
    var genderLabel = genderKey==="womens" ? "Women's" : genderKey==="junior" ? "Junior" : "Men's";

    // (4) shaft flex — full-swing only; women's/junior encode fit via the flex value
    var flexClass = null, flexLabel = null;
    if (fullSwing){
      if (genderKey==="womens"){ flexClass = "ladies"; flexLabel = "Ladies"; }
      else if (genderKey==="junior"){ flexClass = "junior"; flexLabel = "Junior"; }
      else if (cat==="irons"){ flexClass = flexFrom7iron(a.q_dist7); flexLabel = flexName(flexClass); }
      else { flexClass = flexFromDriver(a.q_dist, a.q_game); flexLabel = flexName(flexClass); }
    }

    // forgiveness band from game level
    var forgivenessMap = { new:"Maximum game-improvement", learning:"Game-improvement", getting:"Game-improvement", solid:"Players-distance", low:"Players" };
    var forgiveness = fullSwing ? (forgivenessMap[a.q_game] || "Game-improvement") : null;

    // (3) budget band — true min/max range
    var bands = budgetBands(rawCat, state);
    var band = optById({ options: bands }, a.q_budget) || { min:0, max:1e9, lab:"Any budget" };

    // (5) what matters most / brand
    var priority = (cat==="putter") ? null : (a.q_matters || "forgiveness");
    var brandPref = (cat==="putter") ? a.q_brand : null;

    // (4) club-specific loft target
    var loft = null;
    if (cat==="fairway" || cat==="hybrid") loft = optById(loftQFor(cat), a.q_loft);
    if (cat==="wedges") loft = optById(Q_WEDGE_GOAL, a.q_goal);

    var catLabel = (rawCat==="notsure") ? "Full set (our pick for you)" : CAT_LABEL[cat];
    var priorityShort = { forgiveness:"Forgiveness", distance:"Distance", value:"Best value",
      feel:(cat==="irons" ? "Shot-shaping" : cat==="wedges" ? "Style" : "Feel & control") }[priority] || null;

    // chips — show only what's relevant to this club type
    var chips = [{ k:"Club type", v: catLabel }];
    if (cat==="irons" && a.q_count) chips.push({ k:"Configuration", v: optById(Q_IRON_COUNT, a.q_count).lab });
    if (flexLabel) chips.push({ k:"Shaft flex", v: flexLabel });
    if (forgiveness) chips.push({ k:"Forgiveness", v: forgiveness });
    if (loft) chips.push({ k:"Loft", v: (cat==="wedges" ? (loft.lo + "–" + loft.hi + "°") : loft.lab) });
    if (cat==="putter"){
      if (a.q_ptype) chips.push({ k:"Head", v: optById(Q_PUT_TYPE, a.q_ptype).lab });
      if (a.q_pfeel && a.q_pfeel!=="any") chips.push({ k:"Feel", v: optById(Q_PUT_FEEL, a.q_pfeel).lab });
    }
    if (priorityShort) chips.push({ k:"Priority", v: priorityShort });
    if (brandPref && brandPref!=="any" && brandPref!=="other") chips.push({ k:"Brand", v: optById(Q_PUT_BRAND, brandPref).lab });
    chips.push({ k:"Budget", v: band.lab });
    chips.push({ k:"Fit", v: genderless ? handLabel : (handLabel + " · " + genderLabel) });

    var summary = buildSummary(cat, {
      a:a, catLabel:catLabel, flexLabel:flexLabel, forgiveness:forgiveness, loft:loft,
      priorityShort:priorityShort, handLabel:handLabel, genderLabel:genderLabel, band:band, brandPref:brandPref,
    });

    return {
      cat: cat, chips: chips, summary: summary,
      budgetMin: band.min, budgetMax: band.max, budgetLabel: band.lab,
      priority: priority, brandPref: brandPref,
      hand: hand, genderKey: genderKey, flexClass: flexClass, genderless: genderless,
      forgiveness: forgiveness, loft: loft,
      ironCount: a.q_count || null,
      putterType: a.q_ptype || null, putterFeel: a.q_pfeel || null, putterStroke: a.q_pstroke || null,
    };
  }